/* ============================================================
   AWC — 21+ Age Gate
   Remembers confirmation in localStorage so it only shows once.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'awc-age-verified';
  var gate = document.getElementById('ageGate');
  if (!gate) return;

  var redirect = gate.getAttribute('data-exit-url') || 'https://www.google.com';

  // Already verified — hide immediately without the fade.
  var verified = false;
  try { verified = localStorage.getItem(KEY) === 'true'; } catch (e) {}

  if (verified) {
    gate.classList.add('hidden');
    document.documentElement.style.overflow = '';
  } else {
    document.documentElement.style.overflow = 'hidden';
  }

  var enterBtn = gate.querySelector('[data-age-enter]');
  var exitBtn = gate.querySelector('[data-age-exit]');

  if (enterBtn) {
    enterBtn.addEventListener('click', function () {
      try { localStorage.setItem(KEY, 'true'); } catch (e) {}
      gate.classList.add('hidden');
      document.documentElement.style.overflow = '';
    });
  }

  if (exitBtn) {
    exitBtn.addEventListener('click', function () {
      window.location.href = redirect;
    });
  }
})();
